
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import Paging from '@/shared/components/Paging.vue';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { TransitionModel, SummaryTransitionModel } from '@/models/transition';

import ListTransition from './components/ListTransition.vue';
import FilterBox from './components/FilterBox.vue';

import authService from '@/services/auth-services';
import transitionServices from '@/services/transition-services';
import commonService from '@/services/common-services';
@Component({
    components: {
        ListTransition,
        FilterBox,
        Loading,
        Paging,
    }
})
export default class ListItem extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private summaryOrder: SummaryTransitionModel = new SummaryTransitionModel();
    private listItem: TransitionModel[] = [];
    private isLoading = false;
    private isShowModal = false;
    private customerInfo: any = {};

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async created() {
        await this.getCustomersInfo();
        this.loadData();
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        this.summaryOrder = new SummaryTransitionModel();
        const result = await transitionServices.getList(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpListTransition: TransitionModel[] = [];
            this.pageSettings.total = result.data.total;
            this.summaryOrder = {
                TotalStatusAll: result.data.summary.TotalStatusAll || 0,
                TotalStatus1: result.data.summary.TotalStatus1 || 0,
                TotalStatus2: result.data.summary.TotalStatus2 || 0,
                TotalStatus3: result.data.summary.TotalStatus3 || 0,
                TotalStatus4: result.data.summary.TotalStatus4 || 0,
                TotalStatus5: result.data.summary.TotalStatus5 || 0,
                TotalStatus6: result.data.summary.TotalStatus6 || 0
            };

            for (const item of result.data.data) {
                const transition = new TransitionModel();
                transition.ID = item.ID;
                transition.PackageType = item.PackageType;
                transition.Status = item.Status;
                transition.TransactionCode = item.TransactionCode;
                transition.PackageCode = item.PackageCode;
                transition.OrderID = item.OrderID;
                transition.Weight = item.Weight;
                transition.Length = item.Length;
                transition.Width = item.Width;
                transition.Height = item.Height;
                transition.Volume = item.Volume;
                transition.StoreCNImportDate = item.StoreCNImportDate;
                transition.StoreCNExportDate = item.StoreCNExportDate;
                transition.StoreVNImportDate = item.StoreVNImportDate;
                transition.StoreVNExportDate = item.StoreVNExportDate;
                transition.ProductName = item.ProductName;
                transition.ProductImage = item.ProductImage;
                transition.CreatedDate = item.CreatedDate;
                transition.statusDetail = DATA.billOfLadingStatus.find(x => x.value === item.Status) || { value: 0, name: '', color: '#3b4354' };
                tmpListTransition.push(transition);
            }
            this.listItem = tmpListTransition;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.filterProp.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.filterProp.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'TransactionCode',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'OrderID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private onFilterChanged(data: any) {
        this.filterProp.selectedStatus = data.status;
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }
}
